import { useBaseUpdate } from "../../base/hooks/useBaseUpdate";
import { UpdateCommentSchemaType } from "../schema/UpdateCommentSchema";
import { UpdateRoomConditionResponseSchema, UpdateRoomConditionResponseSchemaType } from "../response/UpdateRoomConditionResponse";

const API_VERSION = "v3";

export const useUpdateComment = () => {
    return useBaseUpdate<{ housekeeping_id: string; data: UpdateCommentSchemaType }, UpdateRoomConditionResponseSchemaType>({
        endpoint: ({ housekeeping_id }) => `${API_VERSION}/housekeeping/${housekeeping_id}/edit-housekeeping-comment`, // Multiple params
        schema: UpdateRoomConditionResponseSchema,
        contentType: "application/json",
        onSuccess: (data) => data,
        onError: (error) => {
            throw error;
        },
    });
};